module.exports = __webpack_public_path__ + "img/Filling_the_Tube.f48d3f8c.png";